import axios from 'axios';
import { CONFIG } from "../config";


const API_BASE = `${CONFIG.API_URL}/api`;

export async function createProduct(formData) {
  try {
    const response = await axios.post(`${API_BASE}/productlist/create/`, formData, {
      withCredentials: true, 
      headers: {
        'X-CSRFToken': getCSRFToken(), 
      },
    });
    return response.data

  } catch (err) {
    const message = err.response?.data?.detail || err.message;
    console.error("Error creating product:", message);
    throw new Error(message);
  }
}


export async function AdminStatusUpdate(id, status) {
  try {
    const response = await axios.patch(
      `${API_BASE}/admin/productlist/status/${id}/`,
      status,
      {
        withCredentials: true,
        headers: {
          "X-CSRFToken": getCSRFToken()},
      }
    );
    return response.data;
  } catch (err) {
    console.error("Error removing product:", err.response?.data || err.message);
    throw err;
  }
}


export async function removeProduct(id, status) {
  try {
    const response = await axios.patch(
      `${API_BASE}/productlist/remove/${id}/`,
      status,
      {
        withCredentials: true,
        headers: {
          "X-CSRFToken": getCSRFToken()},
      }
    );
    return response.data;
  } catch (err) {
    console.error("Error removing product:", err.response?.data || err.message);
    throw err;
  }
}


export async function updateProduct(id, payload, isMultipart = false) {
  try {
    const response = await axios.patch(
      `${API_BASE}/productlist/update/${id}/`,
      payload,
      {
        withCredentials: true,
        headers: {
          "X-CSRFToken": getCSRFToken(),
          ...(isMultipart ? {} : { "Content-Type": "application/json" }),
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Error updating product:", err.response?.data || err.message);
    throw err;
  }
}


function getCSRFToken() {
  const name = 'csrftoken';
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [key, value] = cookie.trim().split('=');
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return '';
}

